import React from 'react';
import PropTypes from 'prop-types';
import GreenCheck from '../../../themes/svg/greenCheck';
import { sites } from '../../../helpers/globalVariables';
import config from '../../../helpers/config';

const SavedToMyAccountMessage = ({ isLinked, isInternalUser, customerEmail }) => {
  const savingInPageTitle = window.globalConfig.siteId === sites.theHomeDepot ? 'My Window Treatments' : 'My Estimates';
  const savingInUrl = window.globalConfig.siteId === sites.theHomeDepot ? `${config.mandiBaseUrl}/mywindowtreatments` : '/myaccount/estimates';

  if (isLinked && !isInternalUser) {
    return (
      <div className="estimateSummaryMessage">
        <GreenCheck />
        <span className="messageText desktop-only inline">
          Now auto-saving in <a href={savingInUrl}>{savingInPageTitle}</a>
        </span>
        <span
          className="messageText tablet-mobile-only inline"
          title={`Now auto-saving in ${savingInPageTitle}`}
        >
          <a href={savingInUrl}>Saved</a>
        </span>
      </div>
    );
  }
  if (isLinked && isInternalUser) {
    return (
      <div className="estimateSummaryMessage">
        <GreenCheck />
        <span className="messageText desktop-only inline">
          Now auto-saving in {customerEmail}&#8217;s {savingInPageTitle}
        </span>
        <span
          className="messageText tablet-mobile-only inline"
          title={`Now auto-saving in ${customerEmail}'s ${savingInPageTitle}`}
        >
          Shared
        </span>
      </div>
    );
  }

  return null;
};

SavedToMyAccountMessage.propTypes = {
  isLinked: PropTypes.bool,
  isInternalUser: PropTypes.bool,
  customerEmail: PropTypes.string,
};
SavedToMyAccountMessage.defaultProps = {
  isLinked: false,
  isInternalUser: false,
  customerEmail: '',
};

export default SavedToMyAccountMessage;
